/** Contact — LOTE M. URL: /contact */
import { useEffect, useState } from 'react';
import { useWww } from './_layout';
import { wwwTheme, wwwRadius, wwwFonts } from '@/src/website/theme';
import { SeoHead } from '@/src/website/SeoHead';
import { SITE_URL, SITE_NAME } from '@/src/website/seo';

// Web equivalent of RN's useWindowDimensions().
function useWindowDimensions() {
  const [size, setSize] = useState(() => ({
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768,
  }));
  useEffect(() => {
    const onResize = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return size;
}

export default function Contact() {
  const { t, lang } = useWww();
  const { width } = useWindowDimensions();
  const isMobile = width < 760;
  // ContactPage Schema.org — useful for "find their contact email" intent.
  const contactJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: t.contactTitle,
    url: `${SITE_URL}/contact`,
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      email: 'support@stilgia.com',
      url: SITE_URL,
    },
  };

  // Web replacement for <Stack.Screen options={{ title: ... }} />: update
  // document.title so the browser tab matches the string the native screen
  // header used in the Expo version. Runs after SeoHead's effect so it has
  // the final word, exactly as in the original render order.
  useEffect(() => {
    document.title = t.contactTitle + ' · STILGIA';
  }, [t.contactTitle]);

  return (
    <>
      <SeoHead page="contact" locale={lang} jsonLd={contactJsonLd} />

      <div style={{ paddingLeft: isMobile ? 24 : 48, paddingRight: isMobile ? 24 : 48, paddingTop: 64, paddingBottom: 80, maxWidth: 820, width: '100%', marginLeft: 'auto', marginRight: 'auto', boxSizing: 'border-box' }}>
        <h1 style={{ color: wwwTheme.text, fontFamily: wwwFonts.serifBold, fontSize: isMobile ? 34 : 46, marginTop: 0, marginBottom: 0 }}>{t.contactTitle}</h1>
        <p style={{ color: wwwTheme.muted, fontSize: 16, marginTop: 12, marginBottom: 0 }}>{t.contactSubtitle}</p>

        <div style={{ backgroundColor: wwwTheme.surface, borderColor: wwwTheme.border, borderWidth: 1, borderStyle: 'solid', borderRadius: wwwRadius.xl, padding: 28, marginTop: 36 }}>
          <span style={{ display: 'block', color: wwwTheme.muted, fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: 8 }}>{t.contactEmailLabel}</span>
          <button data-testid="contact-support-email-button" onClick={() => { window.location.href = 'mailto:support@stilgia.com'; }} style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer', textAlign: 'left', font: 'inherit', color: 'inherit' }}>
            <span style={{ color: wwwTheme.text, fontSize: 22, fontWeight: 600, fontFamily: wwwFonts.serifBold }}>support@stilgia.com</span>
          </button>
          <div style={{ height: 1, backgroundColor: wwwTheme.border, marginTop: 22, marginBottom: 22 }} />
          <span style={{ display: 'block', color: wwwTheme.muted, fontSize: 11, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: 6 }}>{t.contactResponseLabel}</span>
          <p style={{ color: wwwTheme.text, fontSize: 15, lineHeight: '22px', marginTop: 0, marginBottom: 0 }}>{t.contactResponseValue}</p>
        </div>

        <div style={{ marginTop: 36 }}>
          <h2 style={{ color: wwwTheme.text, fontSize: 20, fontWeight: 600, marginTop: 0, marginBottom: 10, fontFamily: wwwFonts.serifBold }}>{t.contactBeforeReachOutTitle}</h2>
          <p style={{ color: wwwTheme.muted, fontSize: 15, lineHeight: '23px', marginTop: 0, marginBottom: 0 }}>{t.contactBeforeReachOutBody}</p>
        </div>
      </div>
    </>
  );
}
